import { cn } from "@/lib/utils";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  intro?: string;
  align?: "left" | "center";
}

// One restrained heading scale for the whole page, matching the sibling
// referral landing: quiet mono eyebrow, medium-weight title, muted intro.
export function SectionHeading({
  eyebrow,
  title,
  intro,
  align = "center",
}: SectionHeadingProps) {
  return (
    <div
      className={cn(
        "mb-10 flex flex-col gap-3",
        align === "center" ? "items-center text-center" : "items-start",
      )}
    >
      <span className="text-marketing-blue font-mono text-[11px] tracking-[0.14em] uppercase">
        {eyebrow}
      </span>
      <h2 className="text-marketing-text dark:text-marketing-cream text-heading-24! sm:text-heading-32! max-w-[26ch] text-balance">
        {title}
      </h2>
      {intro && (
        <p className="text-marketing-text-muted text-copy-16 max-w-[54ch]">
          {intro}
        </p>
      )}
    </div>
  );
}
